"use strict";
/**
 * 该文件用来定义在处理合约可用保证金(available)，保证金（margin），收益，持仓价值等字段时的精度
 * 目前仅支持USDT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuturesCoinPrecision = exports.getFuturesCoinPrecision = void 0;
const react_1 = require("react");
const CalculateUtils_1 = require("../Trade/FutureTrade/CalculateUtils");
/**币对对应的精度定位 */
const FUTURES_COIN_PRECISION_MAP = {
    USDT: 2,
    SOL: 4,
    ETH: 5,
    BTC: 6,
    [CalculateUtils_1.VIRTUAL_CURRENCY]: 2,
};
/**
 * 获取合约基于某个币种的精度，目前只支持USDT
 * @see FuturesCoinType
 */
function getFuturesCoinPrecision(coin = "USDT") {
    var _a;
    return (_a = FUTURES_COIN_PRECISION_MAP[coin]) !== null && _a !== void 0 ? _a : 2;
}
exports.getFuturesCoinPrecision = getFuturesCoinPrecision;
/**
 * 获取合约基于某个币种的精度，目前只支持USDT
 * @see FuturesCoinType
 */
function useFuturesCoinPrecision(coin = "USDT") {
    return (0, react_1.useMemo)(() => getFuturesCoinPrecision(coin), [coin]);
}
exports.useFuturesCoinPrecision = useFuturesCoinPrecision;
